// 未参与态主卡切图常量（来自 unjoined.rd-ui.v1.json 的 assetKey）。
// 三张图与 on-progress（组件优化_4）同视觉，复用 explore-progress-v4 已上传的美团 CDN，不重复上传。
export const UNJOINED_CARD_ASSET = {
    /** 规则入口右箭头 */
    RULE_ARROW: 'https://img.meituan.net/makerjiulv/b2b755bdbc52d51f69a4c24206552730667.png',
    /** 手举¥288 角标 */
    HAND_BADGE: 'https://img.meituan.net/makerjiulv/914a23ccd7a0cfeeb1ae23f3555530d125627.png'
};
